import React from "react";
import "../App.css";

const Features = () => {
  return (
    <section id="features">
      <h2>Key Features</h2>
      <div className="grid">
        <div className="card reveal">
          <h3>Secure Living</h3>
          <p>
            Gated community with 24/7 security, camera surveillance, and three
            fire exits for full safety.
          </p>
        </div>

        <div className="card reveal">
          <h3>Green & Maintained</h3>
          <p>
            Regular cleaning, rubbish collection, and maintenance of all shared
            walls, trees, and green spaces.
          </p>
        </div>

        <div className="card reveal">
          <h3>Modern Infrastructure</h3>
          <p>
            Stone-paved roads and bright streets designed for cars, bicycles,
            scooters, and golf carts.
          </p>
        </div>

        <div className="card reveal">
          <h3>Family-Friendly</h3>
          <p>
            Kids’ playgrounds, outdoor gym, and stroller- and
            wheelchair-friendly walkways.
          </p>
        </div>

        <div className="card reveal">
          <h3>Smart & Sustainable</h3>
          <p>
            Smart home systems, solar energy, and high-speed connectivity for
            modern living.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features;
